import axios from "axios";
import * as misConstantes from "./constantes";

const TOKEN_KEY = "token";
const USER_KEY = "usuario";
const RUTAS_EXCLUIDAS = ["/ServletJWTLogin", "/ServletAutenticarAdministrador"];

let isRefreshing = false;
let subscribers = [];

function onTokenRefreshed(token) {
  subscribers.forEach((callback) => callback(token));
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

/**
 * Verifica si el JWT ha expirado
 */
export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Date.now() > payload.exp * 1000;
  } catch (e) {
    console.warn("Token inválido o corrupto");
    return true;
  }
};

/**
 * Renueva el token usando el correo del usuario autenticado
 */
export const renovarToken = async () => {
  const wrapper = JSON.parse(localStorage.getItem(USER_KEY));
  const correo = wrapper?.usuario?.correo;

  if (!correo) {
    console.warn("No se encontró el correo en el localStorage");
    return null;
  }

  try {
    const response = await axios.post(
      misConstantes.URL_CONSULTA + "/ServletJWTLogin",
      { correo }
    );

    const nuevoToken = response.data.token;
    localStorage.setItem(TOKEN_KEY, nuevoToken);
    return nuevoToken;
  } catch (e) {
    console.error("Error al renovar token", e);
    return null;
  }
};

/**
 * Obtiene un token válido (renueva si está vencido)
 */
export const getValidToken = async () => {
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token || !isTokenExpired(token)) {
    return token;
  }

  if (isRefreshing) {
    return new Promise((resolve) => {
      addSubscriber((newToken) => {
        resolve(newToken);
      });
    });
  }

  isRefreshing = true;

  try {
    const newToken = await renovarToken();
    onTokenRefreshed(newToken);
    return newToken;
  } finally {
    isRefreshing = false;
  }
};

/**
 * Configura el interceptor global de Axios
 */
export const configurarInterceptorAuth = () => {
  axios.interceptors.request.use(
    async (config) => {
      // 👉 Si el usuario tiene el bypass activado en localStorage
      //console.log(localStorage.getItem("qaBypass"));
      config.headers["X-Admin-Bypass"] = localStorage.getItem("qaBypass");
      // Evitar que el interceptor intercepte las rutas excluidas
      if (RUTAS_EXCLUIDAS.some((ruta) => config.url.includes(ruta))) {
        return config;
      }

      const token = await getValidToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
  // Interceptor de respuesta para modo mantenimiento (503)
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 503 &&
        typeof global.onMaintenanceDetected === "function"
      ) {
        global.onMaintenanceDetected(); // activa el estado global
      }
      return Promise.reject(error);
    }
  );
};
